import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    sales: [],
    buys: [],
    expenses: [],
    income: [],
  },
  loading: false,
  error: null,
};

const pnlReportSlice = createSlice({
  name: "PNLReportBasicFormatReducer",
  initialState,
  reducers: {
    fetchPnLDataRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchPnLDataSuccess(state, action) {
      state.loading = false;
      state.data = action.payload; // payload contains { sales, buys, expenses, income }
    },
    fetchPnLDataFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Export actions and reducer
export const {
  fetchPnLDataRequest,
  fetchPnLDataSuccess,
  fetchPnLDataFailure,
} = pnlReportSlice.actions;

export default pnlReportSlice.reducer;